class CartPopup extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.cart-popup_close').addEventListener('click', this.closePopup.bind(this));
  }

  openPopup() {
    console.log('opening');
    this.classList.add('open');
  }

  closePopup() {
    this.classList.remove('open');
  }

  renderContents(parsedState) {
    console.log(parsedState);
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      this.querySelector(section.selector).innerHTML = 
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.openPopup();
    document.dispatchEvent(new CustomEvent('vinyl:cart:changed', { detail: { reason: 'open' } }));

  }

  getSectionsToRender() {
    return [
      {
        id: 'header',
        selector: `.cart-popup_contents`,
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

}

customElements.define('cart-popup', CartPopup);